"use client"
import React, { useContext, useState } from "react"

import styles from "./About.module.scss"

import { ModalContext } from "@/contexts/ModalProvider"
import { getDateWithMonth, isPastEvent, getGMT } from "@/utils/datehelpers.js"
import { useTranslations, useLocale } from "next-intl"

import Container from "../../Container/Container"
import Row from "../../Row/Row"
import Col from "../../Col/Col"
// import Spacer from "../../Spacer/Spacer"
import RegularButton from "../../RegularButton/RegularButton"
import InsightItem from "@/components/Insights/InsightItem"
import Modal from "@/components/Modal/Modal"

export default function About({ item, videos }) {
  const t = useTranslations()
  const lang = useLocale()
  const { setOpenModal } = useContext(ModalContext)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [modalVideo, setModalVideo] = useState("")

  // const testShorts = [
  //   {
  //     title: "Full video of&nbsp;Panel Discussion",
  //     video: "826917081?h=847c56afa1",
  //     image: "/images/event/short-1.jpg",
  //     created_at: new Date(),
  //   },
  //   {
  //     title: "Full video of&nbsp;Panel Discussion",
  //     video: "826917081?h=847c56afa1",
  //     image: "/images/event/short-2.jpg",
  //     created_at: new Date(),
  //   },
  //   {
  //     title: "Full video of&nbsp;Panel Discussion",
  //     video: "826917081?h=847c56afa1",
  //     image: "/images/event/short-3.jpg",
  //     created_at: new Date(),
  //   },
  //   {
  //     title: "Full video of&nbsp;Panel Discussion",
  //     video: "826917081?h=847c56afa1",
  //     image: "/images/event/short-4.jpg",
  //     created_at: new Date(),
  //   },
  //   {
  //     title: "Full video of&nbsp;Panel Discussion",
  //     video: "826917081?h=847c56afa1",
  //     image: "/images/event/short-2.jpg",
  //     created_at: new Date(),
  //   },
  //   {
  //     title: "Full video of&nbsp;Panel Discussion",
  //     video: "826917081?h=847c56afa1",
  //     image: "/images/event/short-3.jpg",
  //     created_at: new Date(),
  //   },
  //   {
  //     title: "Full video of&nbsp;Panel Discussion",
  //     video: "826917081?h=847c56afa1",
  //     image: "/images/event/short-4.jpg",
  //     created_at: new Date(),
  //   },
  // ]

  // const reducedTestShorts = testShorts
  // reducedTestShorts.shift()

  let shorts = []

  if (videos) {
    shorts = videos
  }

  function openVideo(el) {
    setIsModalVisible(false)
    setModalVideo(el.video)

    setIsModalVisible(true)
  }

  function closeModal() {
    setIsModalVisible(false)
  }

  return (
    <section className={styles.about} id="about">
      <Container className={styles.about__container}>
        <Row>
          <Col cols="12" sm="24" lg="12">
            <h2
              dangerouslySetInnerHTML={{ __html: t.raw("events.about.title") }}
            ></h2>
            <div
              className={styles.about__desc}
              dangerouslySetInnerHTML={{ __html: item.description }}
            ></div>
          </Col>

          <Col cols="12" sm="24" lg="12">
            {!isPastEvent(item.date_time, item.time_zone) ? (
              <>
                <div
                  className={styles.about__date}
                  dangerouslySetInnerHTML={{
                    __html: getDateWithMonth(item.date_time, lang),
                  }}
                ></div>
                {item.type === "online" && item.place && (
                  <span className={styles.about__livetext}>
                    live streamed from {item.place.address}
                  </span>
                )}
                <div className={styles.about__timetable}>
                  <div className={styles.about__timetableTitle}>
                    <strong>{t.raw("events.about.timetable")}</strong>
                    {lang !== "pl" && (
                      <span>
                        ({t.raw("events.about.localTime")},{" "}
                        {getGMT(item.time_zone)})
                      </span>
                    )}
                  </div>

                  <ul className={styles.about__timetableList}>
                    {item.timetables.map((el, index) => {
                      return (
                        <li key={index}>
                          <strong>{el.time}</strong>
                          <span>{el.description}</span>
                        </li>
                      )
                    })}
                  </ul>
                </div>
                <RegularButton
                  text={t("events.signUpButtonText")}
                  onClick={() => setOpenModal(true)}
                  shine
                ></RegularButton>
              </>
            ) : (
              item.full_video && (
                <div className={styles.about__video}>
                  <InsightItem
                    item={item.full_video}
                    openVideo={() => openVideo(item.full_video)}
                    withPlay
                    fullView
                    isVideo
                  />
                </div>
              )
            )}
          </Col>
        </Row>

        {isPastEvent(item.date_time, item.time_zone) &&
        shorts &&
        shorts.length ? (
          <div className={styles.about__shorts}>
            <h3>Horizon Shorts</h3>
            <div className={styles.about__shortslist}>
              {shorts.map((el, index) => {
                return (
                  <InsightItem
                    key={index}
                    item={el}
                    className={styles.about__short}
                    openVideo={() => openVideo(el)}
                    withPlay
                    isVideo
                  />
                )
              })}
            </div>
          </div>
        ) : null}
      </Container>

      {isModalVisible && <Modal close={closeModal} video={modalVideo} />}
    </section>
  )
}
